var map = {
	"./1.png": 56,
	"./2.png": 57,
	"./3.png": 58,
	"./4.png": 59,
	"./5.png": 60,
	"./6.png": 61,
	"./7.png": 62,
	"./8.png": 63,
	"./9.png": 64,
	"./img.png": 65,
	"./testmonial.png": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55;